class ComplementaryProductRecommendations extends HTMLElement {
    constructor() {
      super();
  
      if (window.initLazyScript) {
        window.initLazyScript(this, this.init.bind(this), 500);
      } else {
        this.init();
      }
    }
  
    async init() {
      const productId = this.dataset.productId;
      const baseUrl = this.dataset.url;
  
      if (!productId || !baseUrl) return;
  
      try {
        const requestUrl = `${baseUrl}&product_id=${productId}`;
        const response = await fetch(requestUrl);
        if (!response.ok) throw new Error(`Fetch failed. Status: ${response.status}`);
  
        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();
  
        const recommendationsEl = tmpl.content.querySelector('complementary-product-recommendations');
        if (recommendationsEl && recommendationsEl.hasChildNodes()) {
          this.innerHTML = recommendationsEl.innerHTML;
        }
  
        if (window.initLazyImages) {
          window.initLazyImages();
        }
      } catch (error) {
        console.error('Error fetching complementary recommendations:', error);
      }
    }
  }
  
  customElements.define('complementary-product-recommendations', ComplementaryProductRecommendations);